import { LayoutColors, colors } from '@src/core/theme';
import styled from 'styled-components';
import useTranslate from '@src/i18n/useTranslate';
import { BodyRegularSemiBold } from '@src/fonts/typography/Typography';
import { useAppDispatch } from '@src/core/hooks';
import React from 'react';
import { device } from '@src/common/breakpoints';
import { clearPaymentErrors } from '@src/features/payments/store/payment';
import { ProviderFinancialError } from './ProviderFinancialError';

interface GatewayPaymentErrorModalProps {
  title?: string;
  helperText?: string;
}

export const GatewayPaymentErrorModal = (props: GatewayPaymentErrorModalProps) => {
  const { helperText, title } = props;

  const { i18n } = useTranslate();
  const dispatch = useAppDispatch();

  return (
    <Container>
      <Content>
        <ProviderFinancialError title={title} helperText={helperText} horizontalStyle={false} />

        <OkButton onClick={() => dispatch(clearPaymentErrors())}>
          {i18n('checkout_payment_gateway_mismatch_error_ok')}
        </OkButton>
      </Content>
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
`;

const Content = styled.div`
  width: 343px;
  border-radius: 8px;
  background-color: ${LayoutColors.whiteLight};
  padding: 16px;
  display: flex;
  flex-flow: column;
  align-items: center;
  text-align: center;
  gap: 16px;
  margin: auto;

  ${device.mediumTablet} {
    width: 552px;
    padding: 32px;
    gap: 24px;
  }

  @media (max-width: 350px) {
    width: 300px;
  }

  @media (max-width: 310px) {
    width: 270px;
  }
`;

const OkButton = styled.button`
  width: 100%;
  background-color: ${colors.primary[500]};
  height: 44px;
  ${BodyRegularSemiBold};
  border-radius: 4px;
  padding: 8px;
  color: ${LayoutColors.whiteLight};
  cursor: pointer;
  border: none;
  border-style: none;
`;
